import { ReviewDayStatus, ReviewMeetingStatusInfo } from '~/services/types';

/** The single decision every per-meeting content component (scorecards, action items,
 *  moments, data log, class summary) needs to make: whether there's anything to render for
 *  the selected meeting, and if not, why. A `processing` meeting is never an error. */
export type MeetingContentState<TMeeting extends ReviewMeetingStatusInfo> =
  | { kind: 'no-meetings'; dayStatus: ReviewDayStatus | null }
  | { kind: 'processing' }
  | { kind: 'failed'; meetingId: string }
  | { kind: 'content'; meeting: TMeeting };

export function getMeetingContentState<TMeeting extends ReviewMeetingStatusInfo>(
  meetings: TMeeting[] | undefined,
  activeMeetingId: string | undefined,
  dayStatus: ReviewDayStatus | null | undefined,
): MeetingContentState<TMeeting> {
  const list = meetings ?? [];
  if (list.length === 0) {
    return { kind: 'no-meetings', dayStatus: dayStatus ?? null };
  }

  const meeting = list.find((m) => m.meetingId === activeMeetingId) ?? list[0];
  if (!meeting) {
    return { kind: 'no-meetings', dayStatus: dayStatus ?? null };
  }
  if (meeting.status === 'processing') {
    return { kind: 'processing' };
  }
  if (meeting.status === 'failed') {
    return { kind: 'failed', meetingId: meeting.meetingId };
  }
  return { kind: 'content', meeting };
}
